export default __webpack_public_path__ + "static/media/gallery-wip-pommel_07.d08392e9.jpg";